import Vue from 'vue'
import emedia from 'easemob-emedia'
import debounce from 'lodash/debounce'
/* eslint-disable */
// import webrtc from 'easemob-webrtc/EMedia_x1v1_3.4.1.js'

// let webrtc = require('easemob-websdk').default

let httpType = 'http:'
if (process.env.NODE_ENV === 'production') {
  httpType = 'https:'
}

// 防止弹框多次
const key = 'WebIM'

const config = {
  // xmppURL和apiURL在配置了isHttpDNS后, 就没有用了
  xmppURL: httpType + '//im-api-v2.easemob.com/ws',
  apiURL: httpType + '//a1-hk-p.easemob.com',

  /*
   * Application AppKey
   */
  // appkey:"gdpwq123#ceshi",
  appkey: '1115200522168856#yunexhibitionapp',
  /*
   * Application Host
   */
  Host: 'easemob.com',
  /*
   * Whether to use HTTPS
   * @parameter {Boolean} true or false
   */
  https: true,
  // 根据DNS配置
  isHttpDNS: true,
  /*
   * isMultiLoginSessions
   * true: A visitor can sign in to multiple webpages and receive messages at all the webpages.
   * false: A visitor can sign in to only one webpage and receive messages at the webpage.
   */
  isMultiLoginSessions: true,
  /**
   * Whether to use window.doQuery()
   * @parameter {Boolean} true or false
   */
  isWindowSDK: false,
  /**
   * isSandBox=true:  xmppURL: 'im-api.sandbox.easemob.com',  apiURL: '//a1.sdb.easemob.com',
   * isSandBox=false: xmppURL: 'im-api.easemob.com',          apiURL: '//a1-hk-p.easemob.com',
   * @parameter {Boolean} true or false
   */
  isSandBox: false,
  /**
   * Whether to console.log in strophe.log()
   * @parameter {Boolean} true or false
   */
  isDebug: process.env.NODE_ENV !== 'production',
  /**
   * Whether to show logs in strophe
   * @parameter {Boolean} true or false
   */
  isStropheLog: false,
  /**
   * will auto connect the xmpp server autoReconnectNumMax times in background when client is offline.
   * won't auto connect if autoReconnectNumMax=0.
   */
  autoReconnectNumMax: 30,
  /**
   * the interval secons between each atuo reconnectting.
   * works only if autoReconnectMaxNum >= 2.
   */
  autoReconnectInterval: 5,
  /**
   * webrtc supports WebKit and https only
   */
  isWebRTC: true, // window.RTCPeerConnection && /^https\:$/.test(window.location.protocol),
  /**
   *  cn: chinese
   *  us: english
   */
  i18n: 'cn',
  /*
   * Set to auto sign-in
   */
  isAutoLogin: true,
  /**
   * Size of message cache for person to person
   */
  p2pMessageCacheSize: 500,
  /**
   * When a message arrived, the receiver send an ack message to the
   * sender, in order to tell the sender the message has delivered.
   * See call back function onReceivedMessage
   */
  delivery: true,
  /**
   * Size of message cache for group chating like group, chatroom etc
   */
  groupMessageCacheSize: 200,
  /**
   * 5 actual logging methods, ordered and available:
   * 'TRACE', 'DEBUG', 'INFO', 'WARN', 'ERROR'
   */

  loglevel: 'ERROR',

  /**
   * enable localstorage for history messages
   */
  enableLocalStorage: true,
}
const typeMap = {
  chat: 'contact',
  groupchat: 'group',
  chatroom: 'chatroom',
}

// export default
export default ({ store }) => {
  // console.log('store', store)
  let WebIM = {}
  WebIM = require('easemob-websdk').default
  WebIM.config = config
  WebIM.conn = new WebIM.connection({
    appKey: WebIM.config.appkey,
    isHttpDNS: WebIM.config.isHttpDNS,
    isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
    https: WebIM.config.https,
    url: WebIM.config.xmppURL,
    apiUrl: WebIM.config.apiURL,
    isAutoLogin: true,
    heartBeatWait: WebIM.config.heartBeatWait,
    autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
    autoReconnectInterval: WebIM.config.autoReconnectInterval,
    isStropheLog: WebIM.config.isStropheLog,
    delivery: WebIM.config.delivery,
  })

  if (!WebIM.conn.apiUrl) {
    WebIM.conn.apiUrl = WebIM.config.apiURL
  }

  // 发送已读
  const ack = (message) => {
    console.log('发送单条已读回执', message)
    // console.log(message)
    const bodyId = message.id // 需要发送已读回执的消息id
    const msg = new WebIM.message('read', WebIM.conn.getUniqueId())
    msg.set({
      id: bodyId,
      to: message.from,
    })
    WebIM.conn.send(msg.body)
  }

  // 增加总的未读消息
  const addMsgNumber = (type, from) => {
    // 如果已经打开聊天框, 且当前选择的人就是发消息的人, 不增加总未读数
    // console.log('addMsgNumber', type, from)
    if (
      type === 'chat' &&
      -(!store.getters['chat/isChatModelShow'] || store.getters['chat/currentSession'].huanxinId !== from)
    ) {
      store.commit('chat/UPDATE_CHAT_UNREAD_NUM', store.getters['chat/talkUnReadNum'] + 1)
    }
  }

  /**
   * 登录方式
   * normalLogin 正常登录
   * roomLogin 聊天室登录
   * visitorLogin 游客登录
   */

  const initWebIM = async (loginInfo) => {
    console.log('执行initWebIM', loginInfo)
    store.commit('chat/switchWebIMStatus', false)

    const huanxinReg = loginInfo.huanxinReg || loginInfo.huanxinId
    const roomId = loginInfo.roomId

    if (!WebIM.conn.apiUrl) {
      WebIM.conn.apiUrl = WebIM.config.apiURL
    }

    // 如果已经登录, 并且登录的huanxinReg和当前的一样, 不再重新走
    // 如果是聊天室, 要另外判断是否为同一聊天室
    const IMLoginInfo = store.getters['chat/IMLoginInfo']

    if (IMLoginInfo && IMLoginInfo.nickname && huanxinReg === IMLoginInfo.id) {
      store.commit('chat/switchWebIMStatus', true)
      return
    }

    const res = await store.dispatch('getUserInfo')

    console.log('initWebIM_res', res)

    // 如果已经登录, 或者是游客身份
    if ((res && res.code === 0 && res.data.huanxinId) || huanxinReg || roomId) {
      // console.log('如果已经登录, 或者是游客身份的聊天室')
      const options = {
        apiUrl: WebIM.config.apiURL,
        user: (res && res.data && res.data.huanxinId) || huanxinReg,
        pwd: '123456',
        appKey: WebIM.config.appkey,
        success(res) {
          console.log('环信登录成功回调', res)

          // setTimeout(() => {
          //     if (store.getters['chat/allUnReadNum'] > 0) {
          //         store.commit('chat/switchMsgCenterShow', true)
          //     }
          // }, 1800)
          store.commit('chat/switchWebIMStatus', true)

          if (res.access_token && roomId) {
            WebIM.conn.joinChatRoom({
              accessToken: res.access_token,
              roomId, // 聊天室id
              success(res) {
                // console.log('加入环信聊天室suc', res)
                store.commit('chat/UPDATE_CHATROOM_INFO', {
                  status: 'normal',
                  cont: '',
                })
              },
            })
          }
        },
        error(err) {
          console.log('登录失败', err)
        },
      }

      WebIM.conn.open(options)
    }
  }

  WebIM.conn.listen({
    onOpened() {
      store.commit('chat/switchWebIMStatus', true)
    }, // 连接成功回调
    onClosed(message) {
      console.log('onClosed', message)
      store.commit('chat/switchWebIMStatus', false)
    }, // 连接关闭回调
    onTextMessage: (message) => {
      // console.log('收到文本消息', message, store)
      const { from, to, type } = message

      if (message.ext) {
        const chatRoomInfo = JSON.parse(JSON.stringify(store.getters['chat/chatRoomInfo']))
        if (message.ext.end) {
          // console.log('直播结束', message.ext.end)
          store.commit('chat/UPDATE_CHATROOM_INFO', {
            status: 'end',
            corpseNum: chatRoomInfo.corpseNum,
          })
        } else if (message.ext.stop) {
          // console.log('直播禁播', message.ext.stop)
          store.commit('chat/UPDATE_CHATROOM_INFO', {
            status: 'stop',
            cont: message.ext.content,
            corpseNum: chatRoomInfo.corpseNum,
          })
        } else if (message.ext.corpseNum) {
          const corpseNum = message.ext.corpseNum

          if (corpseNum) {
            chatRoomInfo.corpseNum = corpseNum
            store.commit('chat/UPDATE_CHATROOM_INFO', chatRoomInfo)
          }
        } else if (message.ext.noticeType) {
          // TODO 新增站内信 message.ext.noticeType === 'newSysMessage'
          return
        }
      }

      const chatId = type !== 'chat' ? to : from

      addMsgNumber(type, from)

      store.dispatch('chat/updateMsgList', {
        chatType: typeMap[message.type],
        chatId,
        msg: message.data,
        bySelf: false,
        from: message.from,
        mid: message.id,
        type: 'text',
        ...message,
      })

      // console.log(
      //   '收到文本消息收到文本消息',
      //   message.type,
      //   message.from,
      //   store.getters['chat/currentSession'].id
      // )

      // 如果当前聊天框打开, 并且是当前聊天框的人发的消息, 发送已读
      console.log(
        '如果当前聊天框打开, 并且是当前聊天框的人发的消息, 发送已读',
        message,
        store.getters['chat/currentSession'],
      )
      if (message.type === 'chat' && message.from + '' === store.getters['chat/currentSession'].id + '') {
        ack(message)
      }
    }, // 收到文本消息
    onEmojiMessage(message) {
      // 收到表情现在是走到文本消息而不是这里
      // console.log('收到表情消息', message)
    }, // 收到表情消息
    onPictureMessage(message) {
      const { from, to, type } = message
      const chatId = type !== 'chat' ? to : from

      store.dispatch('chat/updateMsgList', {
        chatType: typeMap[type],
        chatId,
        ...message,
        // msg: message.url,
        // bySelf: false,
        // type: 'img',
        // from
      })
      if (message.type === 'chat' && message.from + '' === store.getters['chat/currentSession'].id + '') {
        ack(message)
      }

      addMsgNumber(type, from)
    }, // 收到图片消息
    onCmdMessage(message) {
      // console.log('收到命令消息', message)
    }, // 收到命令消息
    onAudioMessage(message) {
      // console.log('收到音频消息', message)

      const { from, to, type } = message
      const chatId = type !== 'chat' ? to : from

      store.dispatch('chat/updateMsgList', {
        chatType: typeMap[type],
        chatId,
        ...message,
      })
      if (message.type === 'chat' && message.from + '' === store.getters['chat/currentSession'].id + '') {
        ack(message)
      }
      addMsgNumber(type, from)
    }, // 收到音频消息
    onVideoMessage(message) {
      const { from, to, type } = message
      const chatId = type !== 'chat' ? to : from

      store.dispatch('chat/updateMsgList', {
        chatType: typeMap[type],
        chatId,
        ...message,
        // msg: message.url,
        // bySelf: false,
        // type: 'img',
        // from
      })
      if (message.type === 'chat' && message.from + '' === store.getters['chat/currentSession'].id + '') {
        ack(message)
      }

      addMsgNumber(type, from)
    },
    onLocationMessage(message) {
      // console.log('收到位置消息', message)
      const { from, to, type } = message
      const chatId = type !== 'chat' ? to : from

      store.dispatch('chat/updateMsgList', {
        chatType: typeMap[type],
        chatId,
        ...message,
      })
      if (message.type === 'chat' && message.from + '' === store.getters['chat/currentSession'].id + '') {
        ack(message)
      }

      addMsgNumber(type, from)
    }, // 收到位置消息
    onFileMessage(message) {
      const { from, to, type } = message
      const chatId = type !== 'chat' ? to : from

      store.dispatch('chat/updateMsgList', {
        chatType: typeMap[type],
        chatId,
        ...message,
        // msg: message.url,
        // bySelf: false,
        // type: 'img',
        // from
      })
      if (message.type === 'chat' && message.from + '' === store.getters['chat/currentSession'].id + '') {
        ack(message)
      }

      addMsgNumber(type, from)
    }, // 收到文件消息
    onRoster(message) {}, // 处理好友申请
    onInviteMessage(message) {}, // 处理群组邀请
    onOnline(e) {
      // console.log('onOnline', e)
      Vue.$message.success({ content: '网络重连成功', key })
      initWebIM({ status: 'normalLogin' })
      store.commit('chat/switchWebIMStatus', true)
    }, // 本机网络连接成功
    onOffline() {
      // console.log('onOffline')
      store.commit('chat/switchWebIMStatus', false)
      Vue.$message.error({ content: '网络连接异常,请重试！', key })
    }, // 本机网络掉线
    onPresence(msg) {
      console.log('onPresence', msg)
      switch (msg.type) {
        case 'rmChatRoomMute':
          console.log('rmChatRoomMute', msg)
          // 解除聊天室一键禁言
          break
        case 'muteChatRoom':
          console.log('muteChatRoom', msg)
          // 聊天室一键禁言
          break
        case 'rmUserFromChatRoomWhiteList':
          console.log('rmUserFromChatRoomWhiteList', msg)
          // 删除聊天室白名单成员
          break
        case 'addUserToChatRoomWhiteList':
          console.log('addUserToChatRoomWhiteList', msg)
          // 增加聊天室白名单成员
          break
        case 'deleteFile':
          console.log('deleteFile', msg)
          // 删除聊天室文件
          break
        case 'uploadFile':
          console.log('uploadFile', msg)
          // 上传聊天室文件
          break
        case 'deleteAnnouncement':
          console.log('deleteAnnouncement', msg)
          // 删除聊天室公告
          break
        case 'updateAnnouncement':
          console.log('updateAnnouncement', msg)
          // 更新聊天室公告
          break
        case 'removeMute':
          console.log('removeMute', msg)
          // 解除禁言
          break
        case 'addMute':
          console.log('addMute', msg)
          // 禁言
          break
        case 'removeAdmin':
          console.log('removeAdmin', msg)
          // 移除管理员
          break
        case 'addAdmin':
          console.log('addAdmin', msg)
          // 添加管理员
          break
        case 'changeOwner':
          console.log('changeOwner', msg)
          // 转让聊天室
          break
        case 'leaveChatRoom':
          console.log('离开了直播间', msg)

          store.dispatch('chat/updateMsgList', {
            chatType: 'chatroom',
            from: msg.from,
            type: msg.type,
            gid: msg.gid,
            em_leave: 'em_leave',
          })
          // 退出聊天室
          break
        case 'memberJoinChatRoomSuccess':
          // TODO
          console.log('真加入了直播间', msg)
          WebIM.conn.listChatRoomMember({
            pageNum: 1,
            pageSize: 50000,
            chatRoomId: roomId,
            success(res) {
              if (res.data.length) {
                store.dispatch('chat/updateJoinNum', res.data.length)
              }
            },
          })
          store.dispatch('chat/updateMsgList', {
            chatType: 'chatroom',
            from: msg.from,
            type: msg.type,
            gid: msg.gid,
            em_join: 'em_join',
          })
          // 加入聊天室
          break
        case 'leave':
          console.log('leave')
          // 退出群
          break
        case 'join':
          console.log('join')
          // 加入群
          break
        default:
          break
      }
    },
    onError(message) {
      debounce(() => {
        console.log('onError', message)

        if (Number(message.type) === 0) {
          // Vue.$message.error({ content: '请输入账号密码', key })
          store.commit('chat/switchWebIMStatus', false)
        } else if (Number(message.type) === 16) {
          store.commit('chat/switchWebIMStatus', false)
          // TODO 火狐会必定报错
          // Vue.$message.error({
          //   content: 'websocket连接中断, 请刷新页面',
          //   key
          // })
        } else if (Number(message.type) === 28) {
          store.commit('chat/switchWebIMStatus', false)
          // Vue.$message.error({ content: '未登陆', key })
        } else if (Number(message.type) === 999) {
          // 未登录就发送消息
          store.commit('chat/switchWebIMStatus', false)
        } else if (message.data && message.data.data) {
          if (JSON.parse(message.data.data).error_description === 'user not found') {
            // Vue.$message.error({ content: '用户名不存在！', key })
          } else if (JSON.parse(message.data.data).error_description === 'invalid password') {
            Vue.$message.error({ content: '密码无效！', key })
          } else if (JSON.parse(message.data.data).error_description === 'user not activated') {
            Vue.$message.error({ content: '用户已被封禁！', key })
          }
        } else if (Number(message.type) === '504') {
          Vue.$message.error({ content: '消息撤回失败', key })
        } else {
          Vue.$message.error({
            content: message.message,
            key,
          })
        }
      }, 1000)
    }, // 失败回调
    onBlacklistUpdate(list) {
      // 黑名单变动
      // 查询黑名单,将好友拉黑,将好友从黑名单移除都会回调这个函数,list则是黑名单现有的所有好友信息
      console.log(list)
    },
    onRecallMessage(message) {
      message.status = 'recall'
      message.msg = '对方撤回了一条消息'
      message.id = message.mid

      console.log('撤回消息', message)
      store.dispatch('chat/updateMessageFormList', message)
    }, // 收到撤回消息回调
    onReceivedMessage(message) {
      // console.log('onReceivedMessage', message)
    }, // 收到消息送达服务器回执
    onDeliveredMessage(message) {
      // console.log('onDeliveredMessage', message)
    }, // 收到消息送达客户端回执
    onReadMessage(message) {
      // console.log('消息已读回执', message)
      // 查找id所在对话
      // if (
      //   store.getters['chat/msgList'].contact &&
      //   Object.keys(store.getters['chat/msgList'].contact).length > 0
      // ) {
      //   Object.keys(store.getters['chat/msgList'].contact).forEach(
      //     (data) => {
      //       const messageList =
      //         store.getters['chat/msgList'].contact[data]
      //       console.log(messageList)
      //       if (messageList) {
      //         messageList.forEach((data, index) => {
      //           if (data.id == message.mid) {
      //             message = data
      //             message.status = 'read'
      //           }
      //         })
      //       }
      //     }
      //   )
      // }
      store.commit('chat/updateMessageStatus', {
        message,
        status: 'read',
      })
      if (message.status) {
      } else {
        console.log('未匹配到此消息')
      }
    }, // 收到消息已读回执
    onCreateGroup(message) {}, // 创建群组成功回执（需调用createGroupNew）
    onMutedMessage(message) {}, // 如果用户在A群组被禁言,在A群发消息会走这个回调并且消息不会传递给群其它成员
  })
  initWebIM({ status: 'normalLogin' })

  WebIM.emedia = emedia

  Vue.prototype.$initWebIM = initWebIM
  Vue.prototype.$WebIM = WebIM
  return WebIM
}
